const MAX_VAT_RATE = 100;

const MIN_VAT_RATE = 0;

const MAX_DECIMALS_VAT_RATE = 2;

export {
  MAX_VAT_RATE,
  MIN_VAT_RATE,
  MAX_DECIMALS_VAT_RATE
};
